export default __webpack_public_path__ + "static/media/tutor.e92ea2db.png";